import SessionStore from 'stores/shared/session';
import ApiService from '../api';

const MessageService = {
  sendMessage(params) {
    return ApiService.fetch({
      url: `/api/users/${params.recipient_id}/message`,
      method: 'POST',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },
};

export default MessageService;
